export default __webpack_public_path__ + "maps-examples-offline-storage-1200-60f1299f4c5ebd18b623ade448ecf892.png";